import { store } from '../../store/store';

function sendError(data: any, message?: string) {
    let text = '';
    const api = import.meta.env.VITE_SEND_ERROR_API;

    if (!api || !data) return;

    if (message) {
        text = `${message}\n\n`;
    }

    text += `Данные: ${JSON.stringify(data)}\n\n`;

    text += `Путь: ${window.location.href}\n\nПользователь: #${store.getState().user.value.info.account.id}`;

    fetch(`${api}/error`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text }),
    })
        .then(() => {})
        .catch(() => {});
}

export { sendError };
